import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ContentStackItem, ContentStackService } from '@app/core/_services/content-stack.service'
import { RpHomeComponent } from './components/rp-home/rp-home.component'
import { RightPanelHeaderComponent } from './components/right-panel-header/right-panel-header.component'

@Component({
    selector: 'fm-right-panel',
    standalone: true,
    imports: [CommonModule, RpHomeComponent, RightPanelHeaderComponent],
    templateUrl: './right-panel.component.html',
    styleUrl: './right-panel.component.scss',
})
export class RightPanelComponent implements OnInit {
    panelOpen = true
    currentContent: ContentStackItem

    constructor(public contentStackService: ContentStackService) {}

    ngOnInit(): void {
        this.contentStackService.currentContent$.subscribe((content: ContentStackItem) => {
            this.currentContent = content
        })
    }

    onRefreshSelected(): void {
        this.contentStackService.refreshSelected()
    }

    onPanelToggled(): void {
        this.panelOpen = !this.panelOpen
        this.contentStackService.panelToggled()
    }
}
